import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=2bd29705&scoped=true&v-if=this.%24store.getters.isLoggedIn&"
import script from "./CreateUser.vue?vue&type=script&lang=ts&"
export * from "./CreateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd29705",
  null
  
)

export default component.exports